import React from "react";
import { Tabs } from "@commonsku/design-system";
import { ASSIGNED_TASKS, MY_TASKS, MyTasksListKey } from "../../../redux/myTasks";
import TaskTabLabel from "./TaskTabLabel";
import TasksMenuPanel, { TasksMenuPanelProps } from "./TasksMenuPanel";

export interface TasksMenuTabsProps {
  activeTab: MyTasksListKey;
  onTabChange: (tab: MyTasksListKey) => void;
  myTasksNewCount: number;
  assignedTasksNewCount: number;
  panelProps: Omit<TasksMenuPanelProps, "tab">;
}

/** The Your Tasks / Assigned Tasks tab strip, and the active tab's panel. */
const TasksMenuTabs = ({
  activeTab,
  onTabChange,
  myTasksNewCount,
  assignedTasksNewCount,
  panelProps,
}: TasksMenuTabsProps) => (
  <Tabs.Root
    colorPalette="brand"
    value={activeTab}
    size="md"
    variant="line"
    fitted
    onValueChange={(details) => onTabChange(details.value as MyTasksListKey)}
  >
    <Tabs.List>
      <Tabs.Trigger value={MY_TASKS} color="fg.muted" _selected={{ color: "colorPalette.fg" }}>
        <TaskTabLabel label="Your Tasks" newlyPostedCount={myTasksNewCount} />
      </Tabs.Trigger>
      <Tabs.Trigger value={ASSIGNED_TASKS} color="fg.muted" _selected={{ color: "colorPalette.fg" }}>
        <TaskTabLabel label="Assigned Tasks" newlyPostedCount={assignedTasksNewCount} />
      </Tabs.Trigger>
    </Tabs.List>
    <Tabs.Content value={activeTab} _horizontal={{ pt: "2" }}>
      <TasksMenuPanel tab={activeTab} {...panelProps} />
    </Tabs.Content>
  </Tabs.Root>
);

export default TasksMenuTabs;
